const getTimeToCoordinatesRatio = (frequency: number) => {
  return frequency / 1000;
};

export const timeToCoordinates = (time: number, frequency: number) => {
  const ratio = getTimeToCoordinatesRatio(frequency);
  return time * ratio;
};

export const coordinatesToTime = (count: number, frequency: number) => {
  const ratio = getTimeToCoordinatesRatio(frequency);
  return count / ratio;
};

export const toUnixTimestamp = (time: string) => new Date(time).valueOf();

export const secondsToMs = (seconds: number, round = true) => {
  return round ? Math.round(seconds * SECOND) : seconds * SECOND;
};

export const msToSecond = (seconds: number, round = true) => {
  return round ? Math.round(seconds / SECOND) : seconds / SECOND;
};

export const MILLISECOND = 1;

export const SECOND = 1000 * MILLISECOND;

export const MINUTE = 60 * SECOND;

export const HOUR = 60 * MINUTE;

export const MAX_BPM = 300;
